/****************************************************************************************************
 * COMPONENT: CAROUSEL SECTION
 * --------------------------------------------------------------------------------------------------
 * This special carousel section component is used to display multiple sections in a carousel.
 * *************************************************************************************************/

import React, { useEffect, useRef } from 'react';
import { Box, IconButton } from '@mui/material';
import Section from '../Section';
import { SanitySection } from 'src/types/sanity';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import 'swiper/swiper-bundle.css';
import './carousel.css';

register();

interface CarouselProps {
  children: React.ReactNode;
  value: SanitySection[] | null;
}

const Carousel = ({ children, value }: CarouselProps) => {
  //   const swiperElRef = useRef(null);
  const swiperElRef = useRef<HTMLElement>(null);

  useEffect(() => {
    // Ensure the swiper instance is correctly initialized
    const swiperElement = swiperElRef.current;
    if (!swiperElement) return;

    // Optionally, set up any listeners or additional configuration here
  }, []);

  // Function to move to the next slide
  const goToNextSlide = () => {
    // @ts-ignore
    const swiper = swiperElRef.current.swiper;
    if (swiper) {
      swiper.slideNext();
    }
  };

  const nextSlide = (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="29" viewBox="0 0 36 29" fill="none">
      <path
        d="M21.4074 0.999999L34 14.5M21.4074 28L34 14.5M34 14.5L3.63571e-07 14.5"
        stroke="#1A1919"
        stroke-width="2"
      />
    </svg>
  );

  return (
    <>
      {/* {children} */}
      <Box position={'relative'} pb={'30px'}>
        <swiper-container
          ref={swiperElRef}
          pagination={true}
          slides-per-view={1}
          speed={500}
          loop={true}
        >
          {value?.map((section, index) => {
            return (
              <swiper-slide key={index}>
                <Section sections={[value[index]]} carouselItem={true} />
              </swiper-slide>
            );
          })}

          {/* Manual Next Button */}
        </swiper-container>
        <IconButton
          sx={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 10,
          }}
          onClick={goToNextSlide}
        >
          {nextSlide}
        </IconButton>
      </Box>
    </>
  );
};

export default Carousel;
